/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState, useContext, useEffect } from "react";
import "./login.css";
import { useNavigate } from "react-router-dom";
import common from "../config/common.json";
import getGlobalVarContext from "../context/getGlobalVarContext";
import { useIntl } from "react-intl";
import {LoadingSpinner} from '../loadingSpinner/LoadingSpinner'
import crypto from 'crypto-js';

function Login() {
  const { setGlobalVar, globalVar } = useContext(getGlobalVarContext());
  // eslint-disable-next-line no-unused-vars
  const { subID } = globalVar;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingInWeb, setIsLoadingInWeb] = useState(false);
  const navigate = useNavigate();
  const intl = useIntl()

  function profileUrl() {
    var requestOptions = {
      method: "GET"
    };
    fetch(
      `${common.BASEURL}/user/details?email=${
        subID !== null ? subID : localStorage.getItem("sub")
      }`,
      requestOptions
    )
      .then((response) => response.text())
      .then(async (result) => {
        if (result !== "{}") {
          var data = JSON.parse(result)?.msg["profile_url"];
          localStorage.setItem("profile_url", data);
          navigate("/home");
          return 0;
        }
        navigate("/home");
      })
      .catch((error) => {
        navigate("/home");
        return;
      });
  }
  const loginPage = (user, pass) => {
    if (user === undefined || pass === undefined) {
      user = username;
      pass = password;
    }
    if (user === "" || pass === "") {
      setError(intl.formatMessage({ id: "userNameAndPasswordError" }));
      return 0;
    }
    setIsLoading(true);

    var loginDetail = JSON.stringify({
      username: user || username,
      password: pass || password,
    });

    var requestOptions = {
      method: "POST",
      body: loginDetail,
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(`${common.BASEURL}/signIn`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = JSON.parse(result.body);
        localStorage.removeItem("user_logout");
        if (data.success) {
          const token = data.token;
          setGlobalVar((oldData) => ({
            ...oldData,
            email: user,
          }));
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", data.refreshToken);
          localStorage.setItem("email", user);

          var requestOptions = {
            method: "POST",
            body: JSON.stringify({ access_token: token }),
            headers: {
              "Content-Type": "application/json",
            },
          };
          fetch(`${common.BASEURL}/getUserInfo`, requestOptions)
            .then((response) => response.json())
            .then(async (result) => {
              var data = JSON.parse(result);
              if (data.success) {
                data = data.result;
                setGlobalVar((oldData) => ({
                  ...oldData,
                  subID: data.sub,
                }));
                localStorage.setItem("name", data.name);
                localStorage.setItem("phone_number", data.phone_number);
                localStorage.setItem("sub", data.sub);
                localStorage.setItem("k_username", data.k_username);
                localStorage.setItem("k_phone_number", data.k_phone_number);
                localStorage.setItem("last_name", data.family_name);
                localStorage.setItem("sip_id", data.sip_id);
                if (
                  localStorage.getItem("k_username_id") !==
                  localStorage.getItem("k_username")
                ) {
                  var getTimestamp = new Date().getTime() * 10000;
                  localStorage.setItem("logoutTime", getTimestamp.toString());
                  localStorage.setItem("k_username_id", data.k_username);
                }
                profileUrl();
              }
            })
            .catch((error) => {
              setIsLoading(false);
              setIsLoadingInWeb(false)
              console.log("error", error);
            });
        } else {
          //error msg
          setError(data.msg);
          setIsLoading(false);
          setIsLoadingInWeb(false)
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setIsLoadingInWeb(false)
        console.log("error", error);
      });
  };
  const forgotPassword = () => {
    navigate("/forgotpassword");
  };
  function showPassword() {
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
      document.getElementById("showimg").src = intl.formatMessage({
        id: "passwordLogoForEyeOpen",
      });
    } else {
      x.type = "password";
      document.getElementById("showimg").src = intl.formatMessage({
        id: "passwordLogForEyeClose",
      });
    }
  }
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const username = query.get("username");
    var password = query.get("password");
    if(username !== null && password !== null){
      var href=window.location.href
      let password=href.split("&password=")[1]
      var bytes  = crypto.AES.decrypt(password, common.EncryptId);
      var originalText = bytes.toString(crypto.enc.Utf8);
      loginPage(username, originalText);
      setIsLoadingInWeb(true)
    }
  }, []);

  return (
    <>
      <div className="body">
      {isLoadingInWeb ? <LoadingSpinner /> :(
        <div className="page-wrapper">
          <div className="page-container-suu">
            <div className="block-1-suu">
              <div className="content-wrapper">
                <div className="content-box">
                  <img
                    className="logo-img ukraine"
                    src={`../${common.ClientId}_logo.png`}
                  />
                  <h1 className="heading-1">
                    <strong className="bold-text">
                      {intl.formatMessage({
                        id: "mainTitleRegistrationLeftText",
                      })}
                    </strong>
                    <br></br>
                  </h1>
                  <div className="feature-box">
                    <img src="../tagone.svg" alt="" className="feature-icon" />
                    <div className="feature-text">
                      <strong>
                        {intl.formatMessage({ id: "freeCallList1Text" })}
                      </strong>
                    </div>
                  </div>
                  <div className="feature-box">
                    <img src="../carone.svg" alt="" className="feature-icon" />
                    <div className="feature-text">
                      {intl.formatMessage({ id: "interNationalText" })}
                    </div>
                  </div>
                  <div className="feature-box">
                    <img
                      src="../crossone.svg"
                      alt=""
                      className="feature-icon"
                    />
                    <div className="feature-text">
                      {intl.formatMessage({ id: "cancelAnytimeText" })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="legal-box _2">
                <div className="legal-text">
                  {intl.formatMessage(
                    { id: "yearRegistrationReserved" },
                    { name: common.app_name }
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="registion_right_side">
            <div>
              <div>
                <div className="hero_title">
                  <h3 className="light">
                    {intl.formatMessage(
                      { id: "appWelcomeMsg" },
                      { name: common.app_name }
                    )}
                  </h3>
                  <h4 className="second_main_color light">
                    {intl.formatMessage({ id: "appConectMsg1" })}
                    <br /> {intl.formatMessage({ id: "appConectMsg2" })}
                  </h4>
                  <p className="error">{error}</p>
                </div>
                <form>
                  <div className="inputData">
                    <label>{intl.formatMessage({ id: "emailLable" })}</label>
                    <br />
                    <input
                      type="text"
                      className="login_input_main"
                      placeholder="Enter E-mail"
                      onChange={(e) => {
                        setUsername(e.target.value);
                        setError("");
                      }}
                    />
                  </div>
                  <div className="inputData">
                    <label>{intl.formatMessage({ id: "paswordLable" })}</label>
                    <br />
                    <input
                      type="password"
                      placeholder="Enter Password"
                      className="login_input_main password_input"
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setError("");
                      }}
                      id="password"
                    />
                    <i>
                      <img
                        id="showimg"
                        className="eye_icon"
                        src="../close-eye.png"
                        onClick={showPassword}
                      />
                    </i>
                  </div>
                  <button
                    className="btn_log_in"
                    onClick={(e) => {
                      e.preventDefault();
                      loginPage();
                    }}
                  >
                    {isLoading
                      ? intl.formatMessage({ id: "loginButtonName1" })
                      : intl.formatMessage({ id: "loginButtonName" })}
                  </button>
                  <div className="forgrt_link">
                  <a className={("font_main_color forget")} onClick={forgotPassword}>
                  Forgot your password?
                  </a>
                </div>
                </form>
                
                 
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
    </>
  );
}

export default Login;
